import React from "react";
import { Link } from "react-router-dom";

export default function HoteleriaVillaCarlosPazSecundario({ bgColor }) {
  return (
    <>
      <section
        id="hoteleria"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <section className="team-member-section ptb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-4">
                  <h2>HOTELERIA EXCLUSIVA</h2>
                  <h3>All inclusive</h3>
                  <p className="lead">
                  Con acceso a todas las comodidades y atracciones locales, este viaje será una experiencia inolvidable llena de diversión y aventuras en un entorno seguro y acogedor
                  </p>
                  {/* <p className="lead">
                    Consultorio Médico/Calefacción Central Cajas de Seguridad /
                    Vista al mar Desfibrilador / Piscina / Play Room Tarjeta
                    Magnética / Plancha Secador de Pelo / Smart TV Wi-Fi/Open
                    Bar 24hs Drugstore/Discoteca / UP Look
                  </p> */}
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/cordoba/VillaCarlosPaz-hotel376.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hotel 376</h5>
                    <h6>Villa Carlos Paz Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link to="https://www.facebook.com/hotel.376" target="_blank" rel="noopener noreferrer">
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to="https://instagram.com/hotel.376" target="_blank" rel="noopener noreferrer">
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                    <a
                      href="https://hotel376.com.ar/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/cordoba/VillaCarlosPaz-HostalCosta.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hostal de la Costa</h5>
                    <h6>a pasos de la Costa</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      <li className="list-inline-item">
                        <Link to="https://www.facebook.com/HostaldelaCosta.CarlosPaz/?locale=es_LA" target="_blank" rel="noopener noreferrer">
                          <span className="ti-facebook"></span>
                        </Link>
                      </li>
                      <li className="list-inline-item">
                        <Link to="https://www.instagram.com/hostaldelacosta.cp/" target="_blank" rel="noopener noreferrer">
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="single-team-member position-relative my-lg-3 my-md-3 my-sm-0">
                  <div className="team-image">
                    <img
                      src="assets/img/cordoba/villaCarlosPaz-hipocampus.jpg"
                      alt="Team Members"
                      className="img-fluid rounded"
                    />
                  </div>
                  <div className="team-info text-white rounded d-flex flex-column align-items-center justify-content-center">
                    <h5 className="mb-0">Hotel Resort Hipocampus</h5>
                    <h6>Villa Carlos Paz Centro</h6>
                    <ul className="list-inline team-social social-icon my-4 text-white">
                      {/* <li className="list-inline-item">
                        <Link to="http://facebook.com/hmhotelbc">
                          <span className="ti-facebook"></span>
                        </Link>
                      </li> */}
                      <li className="list-inline-item">
                        <Link to="https://www.instagram.com/hipocampushotel/?hl=es" target="_blank" rel="noopener noreferrer">
                          <span className="ti-instagram"></span>
                        </Link>
                      </li>
                    </ul>
                    <a
                      href="https://hipocampushotel.com.ar/"
                      target="_blank"
                      rel="noreferrer"
                      className="btn app-store-btn"
                    >
                      Ver hotel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
}
